// extracted by mini-css-extract-plugin
module.exports = {"accordionComponentWrapper":"kn","header":"ko","accordionWrapper":"kp","accordionHeader":"kq","accordionIcon":"kr","accordionContent":"ks"};